import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Code, Alert, Group, Button, Space, Text, Modal, createStyles, useMantineTheme, TextInput } from '@mantine/core';
import { IconCircleCheck, IconExclamationCircle, IconX, IconCloudUpload, IconDownload } from '@tabler/icons-react';
import { Dropzone } from '@mantine/dropzone';

const useStyles = createStyles((theme) => ({
    dropzone: {
        position: 'relative',
        background: 'white !important',
        '&[data-accept]': {
            background: 'white',
        },

        '&[data-reject]': {
            background: 'white'
        },
    },

    dropzoneDisabled: {
        backgroundColor: theme.colors.gray[0],
        borderColor: theme.colors.gray[2],
        cursor: 'not-allowed',

        '& *': {
            color: theme.colors.gray[5],
        },
    },

    flexText: {
        display: 'flex',
        width: '100%',
        flexGrow: 1,
    },

    flexTextSpan: {
        fontWeight: 600,
        display: 'flex',
        flex: 1,
        textAlign: 'right',

        // Before
        '&::before': {
            content: '""',
            borderBottom: `1.5px dotted ${theme.colors.gray[5]}`,
            flexGrow: 1,
            display: 'inline-block',
            height: '1px',
            transform: 'translateY(1.05em)',
            margin: '0 0.4em',
        }
    },
}));

const downloadCSVExample = () => {
    const exampleData = `StartDate,EndDate,Status,IPAddress,Progress,Duration (in seconds),Finished,RecordedDate,ResponseId,RecipientLastName,RecipientFirstName,RecipientEmail,ExternalReference,LocationLatitude,LocationLongitude,DistributionChannel,UserLanguage,Q1,Q2,Q3,alias_data
Start Date,End Date,Response Type,IP Address,Progress,Duration (in seconds),Finished,Recorded Date,Response ID,Recipient Last Name,Recipient First Name,Recipient Email,External Data Reference,Location Latitude,Location Longitude,Distribution Channel,User Language,Tell us about yourself,What words would you use to describe this product?,How old are you?,alias_data
"{""ImportId"":""startDate"",""timeZone"":""America/New_York""}","{""ImportId"":""endDate"",""timeZone"":""America/New_York""}","{""ImportId"":""status""}","{""ImportId"":""ipAddress""}","{""ImportId"":""progress""}","{""ImportId"":""duration""}","{""ImportId"":""finished""}","{""ImportId"":""recordedDate"",""timeZone"":""America/New_York""}","{""ImportId"":""_recordId""}","{""ImportId"":""recipientLastName""}","{""ImportId"":""recipientFirstName""}","{""ImportId"":""recipientEmail""}","{""ImportId"":""externalDataReference""}","{""ImportId"":""locationLatitude""}","{""ImportId"":""locationLongitude""}","{""ImportId"":""distributionChannel""}","{""ImportId"":""userLanguage""}","{""ImportId"":""QID1_TEXT""}","{""ImportId"":""QID7_TEXT""}","{""ImportId"":""QID2""}","{""ImportId"":""alias_data""}"
2024-10-17 13:10:18,2024-10-17 13:10:56,Survey Preview,,100,37,True,2024-10-17 13:10:56,R_3B4UwKPoxlzn6md,,,,,37.7833,-122.4952,preview,EN,My name is Matt and I like to code,"It's great, easy to use, love it.",31-50,"{""questions"":{""QID1"":""Tell us about yourself"",""QID7"":""What words would you use to describe this product?""},""question_histories"":{""QID1"":[{""s"":""M"",""t"":0},{""s"":""My"",""t"":726},{""s"":""My "",""t"":880},{""s"":""My n"",""t"":1028},{""s"":""My na"",""t"":1122},{""s"":""My nam"",""t"":1190},{""s"":""My name"",""t"":1293},{""s"":""My name "",""t"":1329},{""s"":""My name i"",""t"":1473},{""s"":""My name is"",""t"":1537},{""s"":""My name is "",""t"":1666},{""s"":""My name is M"",""t"":1859},{""s"":""My name is Ma"",""t"":1920},{""s"":""My name is Mat"",""t"":2053},{""s"":""My name is Matt"",""t"":2221},{""s"":""My name is Matt "",""t"":2289},{""s"":""My name is Matt a"",""t"":2388},{""s"":""My name is Matt an"",""t"":2467},{""s"":""My name is Matt and"",""t"":2570},{""s"":""My name is Matt and "",""t"":2642},{""s"":""My name is Matt and I"",""t"":2825},{""s"":""My name is Matt and I'"",""t"":2980},{""s"":""My name is Matt and I"",""t"":3533},{""s"":""My name is Matt and I "",""t"":4015},{""s"":""My name is Matt and I l"",""t"":4157},{""s"":""My name is Matt and I li"",""t"":4334},{""s"":""My name is Matt and I lik"",""t"":4489},{""s"":""My name is Matt and I like"",""t"":4918},{""s"":""My name is Matt and I like "",""t"":5058},{""s"":""My name is Matt and I like t"",""t"":5162},{""s"":""My name is Matt and I like to"",""t"":5225},{""s"":""My name is Matt and I like to "",""t"":5375},{""s"":""My name is Matt and I like to c"",""t"":5469},{""s"":""My name is Matt and I like to co"",""t"":5545},{""s"":""My name is Matt and I like to cod"",""t"":5642},{""s"":""My name is Matt and I like to code"",""t"":5710}],""QID7"":[{""s"":""I"",""t"":0},{""s"":""It"",""t"":147},{""s"":""It'"",""t"":232},{""s"":""It's"",""t"":331},{""s"":""It's "",""t"":492},{""s"":""It's g"",""t"":1165},{""s"":""It's gr"",""t"":1359},{""s"":""It's gre"",""t"":1439},{""s"":""It's grea"",""t"":1530},{""s"":""It's great"",""t"":1639},{""s"":""It's great,"",""t"":1837},{""s"":""It's great, "",""t"":1975},{""s"":""It's great, e"",""t"":2047},{""s"":""It's great, ea"",""t"":2164},{""s"":""It's great, eas"",""t"":2232},{""s"":""It's great, easy"",""t"":2297},{""s"":""It's great, easy "",""t"":2434},{""s"":""It's great, easy t"",""t"":2549},{""s"":""It's great, easy to"",""t"":2594},{""s"":""It's great, easy to "",""t"":2749},{""s"":""It's great, easy to u"",""t"":2869},{""s"":""It's great, easy to us"",""t"":2917},{""s"":""It's great, easy to use"",""t"":2993},{""s"":""It's great, easy to use,"",""t"":3170},{""s"":""It's great, easy to use, "",""t"":3420},{""s"":""It's great, easy to use, l"",""t"":3717},{""s"":""It's great, easy to use, lo"",""t"":3910},{""s"":""It's great, easy to use, lov"",""t"":3994},{""s"":""It's great, easy to use, love"",""t"":4124},{""s"":""It's great, easy to use, love "",""t"":4180},{""s"":""It's great, easy to use, love i"",""t"":4309},{""s"":""It's great, easy to use, love it"",""t"":4381},{""s"":""It's great, easy to use, love it."",""t"":4464}]},""responses"":{""QID1"":""My name is Matt and I like to code"",""QID7"":""It's great, easy to use, love it.""},""fingerprint_id"":""1736978872680.3BHKKS""}"
2024-10-17 13:11:03,2024-10-17 13:11:17,Survey Preview,,100,14,True,2024-10-17 13:11:17,R_3iWFZb2ZZIEypOc,,,,,37.7833,-122.4952,preview,EN,great one day george washington crossed the delaware,alks. alisdjsj alsdjsalskdj alss,18-30,"{""questions"":{""QID1"":""Tell us about yourself"",""QID7"":""What words would you use to describe this product?""},""question_histories"":{""QID1"":[{""s"":""g"",""t"":0},{""s"":""gr"",""t"":247},{""s"":""gre"",""t"":311},{""s"":""grea"",""t"":370},{""s"":""great"",""t"":512},{""s"":""great "",""t"":609},{""s"":""great o"",""t"":1716},{""s"":""great on"",""t"":1748},{""s"":""great one"",""t"":1859},{""s"":""great one "",""t"":1944},{""s"":""great one d"",""t"":2028},{""s"":""great one da"",""t"":2112},{""s"":""great one day"",""t"":2140},{""s"":""great one day "",""t"":2275},{""s"":""great one day g"",""t"":2463},{""s"":""great one day ge"",""t"":2538},{""s"":""great one day geo"",""t"":2606},{""s"":""great one day geor"",""t"":2721},{""s"":""great one day georg"",""t"":2785},{""s"":""great one day george"",""t"":2877},{""s"":""great one day george "",""t"":3021},{""s"":""great one day george w"",""t"":3195},{""s"":""great one day george wa"",""t"":3280},{""s"":""great one day george was"",""t"":3368},{""s"":""great one day george wash"",""t"":3461},{""s"":""great one day george washi"",""t"":3569},{""s"":""great one day george washin"",""t"":3666},{""s"":""great one day george washing"",""t"":3714},{""s"":""great one day george washingt"",""t"":3886},{""s"":""great one day george washingto"",""t"":3910},{""s"":""great one day george washington"",""t"":3989},{""s"":""great one day george washington "",""t"":4184},{""s"":""great one day george washington c"",""t"":4345},{""s"":""great one day george washington cr"",""t"":4506},{""s"":""great one day george washington cro"",""t"":4613},{""s"":""great one day george washington cros"",""t"":4718},{""s"":""great one day george washington cross"",""t"":4888},{""s"":""great one day george washington crosse"",""t"":4988},{""s"":""great one day george washington crossed"",""t"":5089},{""s"":""great one day george washington crossed "",""t"":5214},{""s"":""great one day george washington crossed t"",""t"":5330},{""s"":""great one day george washington crossed th"",""t"":5387},{""s"":""great one day george washington crossed the"",""t"":5483},{""s"":""great one day george washington crossed the "",""t"":5549},{""s"":""great one day george washington crossed the d"",""t"":5643},{""s"":""great one day george washington crossed the de"",""t"":5722},{""s"":""great one day george washington crossed the del"",""t"":5774},{""s"":""great one day george washington crossed the dela"",""t"":5943},{""s"":""great one day george washington crossed the delaw"",""t"":6031},{""s"":""great one day george washington crossed the delawa"",""t"":6130},{""s"":""great one day george washington crossed the delawar"",""t"":6259},{""s"":""great one day george washington crossed the delaware"",""t"":6341}],""QID7"":[{""s"":""a"",""t"":0},{""s"":""al"",""t"":23},{""s"":""alk"",""t"":204},{""s"":""alks"",""t"":248},{""s"":""alks "",""t"":426},{""s"":""alks. "",""t"":558},{""s"":""alks. a"",""t"":721},{""s"":""alks. al"",""t"":784},{""s"":""alks. ali"",""t"":879},{""s"":""alks. alis"",""t"":935},{""s"":""alks. alisd"",""t"":999},{""s"":""alks. alisdj"",""t"":1005},{""s"":""alks. alisdjs"",""t"":1187},{""s"":""alks. alisdjsj"",""t"":1194},{""s"":""alks. alisdjsj "",""t"":1381},{""s"":""alks. alisdjsj a"",""t"":1512},{""s"":""alks. alisdjsj al"",""t"":1548},{""s"":""alks. alisdjsj als"",""t"":1600},{""s"":""alks. alisdjsj alsd"",""t"":1667},{""s"":""alks. alisdjsj alsdj"",""t"":1744},{""s"":""alks. alisdjsj alsdjs"",""t"":1795},{""s"":""alks. alisdjsj alsdjsa"",""t"":1799},{""s"":""alks. alisdjsj alsdjsal"",""t"":1896},{""s"":""alks. alisdjsj alsdjsals"",""t"":1955},{""s"":""alks. alisdjsj alsdjsalsk"",""t"":2004},{""s"":""alks. alisdjsj alsdjsalskd"",""t"":2007},{""s"":""alks. alisdjsj alsdjsalskdj"",""t"":2079},{""s"":""alks. alisdjsj alsdjsalskdj "",""t"":2253},{""s"":""alks. alisdjsj alsdjsalskdj a"",""t"":2432},{""s"":""alks. alisdjsj alsdjsalskdj al"",""t"":2452},{""s"":""alks. alisdjsj alsdjsalskdj als"",""t"":2524},{""s"":""alks. alisdjsj alsdjsalskdj alss"",""t"":2743}]},""responses"":{""QID1"":""great one day george washington crossed the delaware"",""QID7"":""alks. alisdjsj alsdjsalskdj alss""},""fingerprint_id"":""1736978717555.uJA9AW""}"`;
    // Download to alias-example.csv
    const element = document.createElement('a');
    const file = new Blob([exampleData], { type: 'text/csv' });
    element.href = URL.createObjectURL(file);
    element.download = 'alias-qualtrics-example.csv';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    document.body.removeChild(element);
};


const checkCSVRequirements = async (csv) => {
    // Call netlify function here to check if the CSV is valid
    const surveyChecks = await fetch("/.netlify/functions/checkQualtricsCSV", { method: "POST", body: JSON.stringify({ csv }) });
    const { valid, errors, numRows } = await surveyChecks.json();
    return { valid, errors, num_rows: numRows };
};

const QualtricsFileUpload = ({ currentUser, APICreditsAvailable, setAPICreditsAvailable, qualtricsModalOpened, setQualtricsModalOpened, surveyIds, setSurveyIds, loadingSurveys, setLoadingSurveys }) => {

    const theme = useMantineTheme();
    const [wrongFileType, setWrongFileType] = useState(false);
    const [filename, setFilename] = useState('');
    const [fileOk, setFileOk] = useState(false);
    const [errorReadingFile, setErrorReadingFile] = useState(false);
    const [wrongFileFormat, setWrongFileFormat] = useState(false);
    const [fileFormatProblems, setFileFormatProblems] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [numRows, setNumRows] = useState(0);
    const [csvData, setCsvData] = useState([]);
    const [isStartingCall, setIsStartingCall] = useState(false);
    const [startedCall, setStartedCall] = useState(false);
    const [surveyId, setSurveyId] = useState('');
    const [wrongSurveyId, setWrongSurveyId] = useState(false);

    const { cx, classes } = useStyles();

    const dropZoneOverlayStyes = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        borderRadius: theme.radius.lg
    };

    const prepareForUpload = async (filenameArray) => {
        resetState();
        if (filenameArray.length === 0) return;
        const file = filenameArray[0];
        if (file.size > 5 * 1024 * 1024) { // 5 MB in bytes
            setWrongFileFormat(true);
            setFileFormatProblems(['File size exceeds 5MB']);
            return;
        }
        setUploading(true);
        setFilename(file.name);
        setSurveyId(file.name.replace(/\.csv$/, ""));
        await parseData(file);
    };

    const resetState = () => {
        setWrongFileType(false);
        setFilename('');
        setFileOk(false);
        setErrorReadingFile(false);
        setWrongFileFormat(false);
        setFileFormatProblems([]);
        setUploading(false);
        setNumRows(0);
        setCsvData([]);
        setIsStartingCall(false);
        setStartedCall(false);
        setSurveyId('');
        setWrongSurveyId(false);
    };


    const parseData = async (file) => {
        if (!file) return;

        try {
            const reader = new FileReader();
            reader.onload = async (e) => {
                // Encode the file content in base64
                const base64Content = e.target.result.split(',')[1];

                // Convert the base64 encoded content to UTF-8 by calling your Netlify function
                const conversionResponse = await fetch("/.netlify/functions/convert-to-utf8", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ fileContent: base64Content }),
                });

                const conversionResult = await conversionResponse.json();
                if (!conversionResult.success) {
                    setErrorReadingFile(true);
                    setUploading(false);
                    return;
                }

                const { valid, errors, num_rows } = await checkCSVRequirements(conversionResult.utf8Text);

                if (valid) {
                    setFileOk(true);
                    setCsvData([conversionResult.utf8Text]);
                    setNumRows(num_rows);
                } else {
                    setFileOk(false);
                    setWrongFileFormat(true);
                    setFileFormatProblems(errors);
                }
                setUploading(false);
            };

            reader.onerror = (e) => {
                console.log('Error reading file:', e);
                setErrorReadingFile(true);
            };

            reader.readAsDataURL(file);
        } catch (error) {
            console.error('Error uploading file:', error);
            setErrorReadingFile(true);
        }
    }

    const uploadToFirestore = async () => {
        const callHash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        try {
            // Upload to firestore using Promise.all
            const uploadPromises = csvData.map((chunk, index) => {
                const data = JSON.stringify({ csvData: chunk, userId: currentUser.uid, filename, callHash, surveyId });
                return fetch("/.netlify/functions/upload-qualtrics-to-firestore", { method: "POST", body: data });
            });
            const responses = await Promise.all(uploadPromises);
            const allSuccess = responses.every(response => response.status === 200);
            if (allSuccess) {
                // Initialize survey calls by calling netlify function `initialize-qualtrics-call`
                const dataForFetch = JSON.stringify({ surveyId, userId: currentUser.uid, callHash, numRows });
                const initializeCall = await fetch("/.netlify/functions/initialize-qualtrics-call", { method: "POST", body: dataForFetch });
                const { success } = await initializeCall.json();
                if (success) {
                    setStartedCall(true);
                    setAPICreditsAvailable(APICreditsAvailable - numRows);
                } else {
                    setErrorReadingFile(true);
                }
            } else {
                setErrorReadingFile(true);
            }
        } catch (error) {
            setErrorReadingFile(true);
        }
    };

    const runAliasAPI = async () => {
        setIsStartingCall(true);
        const surveyIdAlreadyExists = surveyIds.includes(surveyId);
        if (surveyIdAlreadyExists) {
            setWrongSurveyId(true);
            setIsStartingCall(false);
            return;
        }
        await uploadToFirestore();
        setLoadingSurveys([...loadingSurveys, surveyId]);
        // Update survey ids
        const sortedSurveys = [...surveyIds, surveyId].sort();
        setSurveyIds(sortedSurveys);
        setIsStartingCall(false);
    };

    return (
        <Modal
            opened={qualtricsModalOpened}
            radius='lg'
            title={'Upload Qualtrics CSV and call Alias API'}
            centered
            padding='xl'
            size={500}
            className={classes.modal}
            onClose={() => {
                resetState();
                if (!uploading) setQualtricsModalOpened(false);
            }}
            withCloseButton={uploading === false}
        >
            {
                startedCall ?
                    <Text size='sm'>
                        Your API calls have been started. The results will appear under "Your Surveys" and <Code>{surveyId}</Code> and will be streamed until they complete (refresh to page to reload and check). If the survey doesn't finish within 24 hours, please contact us at support@roundtable.ai.
                    </Text>
                    :
                    <>
                        <Dropzone
                            onDrop={prepareForUpload}
                            onReject={() => {
                                setWrongFileType(true);
                            }}
                            multiple={false}
                            radius='lg'
                            accept={['text/csv']}
                            className={uploading === false ? classes.dropzone : cx(classes.dropzone, classes.dropzoneDisabled)}
                            loading={uploading}
                            disabled={uploading}
                        >
                            <Space h='md' />
                            <Dropzone.Reject>
                                <div style={{ ...dropZoneOverlayStyes, background: 'rgba(255,0,0,0.05)' }} />
                            </Dropzone.Reject>
                            <Dropzone.Accept>
                                <div style={{ ...dropZoneOverlayStyes, background: 'rgba(0,0,0,0.05)' }} />
                            </Dropzone.Accept>
                            <Group position="center">
                                <Dropzone.Accept>
                                    <IconCloudUpload
                                        size={40}
                                        stroke={1.5}
                                        color={theme.colors[theme.primaryColor][6]}
                                    />
                                </Dropzone.Accept>
                                <Dropzone.Reject>
                                    <IconX
                                        size={40}
                                        stroke={1.5}
                                        color={theme.colors.red[6]}
                                    />
                                </Dropzone.Reject>
                                <Dropzone.Idle>
                                    <IconCloudUpload
                                        size={40}
                                        stroke={1.5}
                                        color={uploading ? theme.colors.gray[5] : theme.colors[theme.primaryColor][6]}
                                    />
                                </Dropzone.Idle>
                            </Group>
                            <Space h='md' />
                            <Text size="lg" ta='center'>
                                Upload a CSV file or drop it here
                            </Text>
                            <Space h='md' />
                        </Dropzone>
                        <Space h='xl' />
                        {
                            wrongFileType ?
                                <>
                                    <Alert
                                        color='red'
                                        radius='md'
                                        title='Please upload a CSV file'
                                        styles={{ title: { margin: '0px' } }}
                                        icon={<IconExclamationCircle size='20' stroke='1.5' />}
                                    />
                                    <Space h='md' />
                                </>
                                :
                                errorReadingFile ?
                                    <>
                                        <Alert
                                            color='red'
                                            radius='md'
                                            title={`Problem uploading file. Please try again`}
                                            styles={{ title: { margin: '0px' } }}
                                            icon={<IconExclamationCircle size='20' stroke='1.5' />}
                                        />
                                        <Space h='md' />
                                    </>
                                    :
                                    wrongFileFormat ?
                                        <>
                                            <Alert
                                                color='red'
                                                radius='md'
                                                title={`Problem uploading file`}
                                                icon={<IconExclamationCircle size='20' stroke='1.5' />}
                                            >
                                                <Text>
                                                    {fileFormatProblems.join('; ')}
                                                </Text>
                                            </Alert>
                                            <Space h='md' />
                                        </>
                                        :
                                        fileOk && filename &&
                                        <>
                                            <Alert
                                                color='teal'
                                                radius='md'
                                                title={`Uploaded ${filename}`}
                                                icon={<IconCircleCheck size='20' stroke='1.5' />}
                                                styles={{ title: { margin: '0px' } }}
                                            />
                                            <Space h='md' />
                                        </>
                        }
                        {
                            fileOk && filename ?
                                <>
                                    <>
                                        <Text size='sm' color='dimmed'>
                                            The Alias API will be called for every participant in the uploaded dataset. This may take up to an hour.
                                        </Text>
                                        <Space h='md' />
                                    </>
                                    <>
                                        <Text className={classes.flexText}>
                                            Number of API credits required
                                            <Text component='span' className={classes.flexTextSpan}>{numRows.toLocaleString()}</Text>
                                        </Text>
                                        <Space h='xs' />
                                        <Text className={classes.flexText}>
                                            Your API credit balance
                                            <Text component='span' className={classes.flexTextSpan}>{APICreditsAvailable.toLocaleString()}</Text>
                                        </Text>
                                        <Space h='xs' />
                                        <Text className={classes.flexText}>
                                            {
                                                APICreditsAvailable - numRows < 0 ?
                                                    'Number of API credits required'
                                                    :
                                                    'Number of API credits remaining'
                                            }
                                            <Text component='span' className={classes.flexTextSpan}>
                                                {Math.abs((APICreditsAvailable - numRows)).toLocaleString()}
                                            </Text>
                                        </Text>
                                        <Space h='md' />
                                        <TextInput
                                            placeholder="survey123"
                                            label="Enter a survey id"
                                            description="Must be at least 6 characters"
                                            size='md'
                                            onChange={(e) => {
                                                if (wrongSurveyId) setWrongSurveyId(false);
                                                setSurveyId(e.target.value)
                                            }}
                                            value={surveyId}
                                            radius='md'

                                        />
                                        <Space h='sm' />
                                        {
                                            APICreditsAvailable - numRows < 0 ?
                                                <Button
                                                    radius='md'
                                                    size='md'
                                                    sx={{ width: '100%' }}
                                                    color='red'
                                                    variant='outline'
                                                    component={Link}
                                                    to='/account'
                                                >
                                                    Buy {
                                                        (numRows - APICreditsAvailable) < 100 ?
                                                            ''
                                                            :
                                                            Math.abs((APICreditsAvailable - numRows)).toLocaleString()
                                                    } credits
                                                </Button>
                                                :
                                                <>
                                                    {
                                                        wrongSurveyId &&
                                                        <>
                                                            <Space h='sm' />
                                                            <Alert
                                                                color='red'
                                                                radius='md'
                                                                title='Survey id already exists'
                                                                styles={{ title: { margin: '0px' } }}
                                                                icon={<IconExclamationCircle size='20' stroke='1.5' />}
                                                            />
                                                            <Space h='md' />
                                                        </>
                                                    }
                                                    <Button
                                                        radius='md'
                                                        size='md'
                                                        sx={{ width: '100%' }}
                                                        onClick={runAliasAPI}
                                                        loading={isStartingCall}
                                                        disabled={isStartingCall || surveyId.length < 6}
                                                    >
                                                        {isStartingCall === false && 'Run Alias API on dataset'}
                                                    </Button>
                                                </>
                                        }
                                    </>
                                </>
                                :
                                <>
                                    <Text size='sm' color='dimmed'>
                                        Data should be a Qualtrics CSV export from a survey with our <a href='https://alias-docs.roundtable.ai/qualtrics' target='_blank' rel='noreferrer'>Qualtrics integration</a>.
                                    </Text>
                                    <Space h='md' />
                                    <Button
                                        variant='subtle'
                                        size='sm'
                                        radius='md'
                                        leftIcon={<IconDownload size={16} stroke={1.5} />}
                                        onClick={downloadCSVExample}

                                    >
                                        Download example CSV
                                    </Button>
                                </>
                        }
                    </>
            }
        </Modal>
    )
};

export default QualtricsFileUpload;